/**
 * `weighted-terms` v1 — terms ranked by a weight.
 *
 * The weight is one measure in one unit for every term (for example observed
 * streams). Terms arrive already bounded by the source; the widget ranks them
 * again by weight so it never depends on the order it received.
 */
export const WEIGHTED_TERMS_CONTRACT = {
  name: "weighted-terms",
  version: 1,
} as const;

export interface WeightedTerm {
  id: string;
  label: string;
  weight: number;
}

export interface WeightedTermsFreshness {
  generatedAt: string;
  dataThrough: string;
  /** "demo", "clickhouse", or a named upstream feed. */
  source: string;
  isEstimated: boolean;
}

export interface WeightedTermsData {
  terms: WeightedTerm[];
  freshness: WeightedTermsFreshness | null;
}
